export default {


  // Tisk vybraného objektu
  // CssNames je pole názvů css souborů
  PrintObj(Obj, Title, CssNames) {

    var windowName = 'DsNliTisk';
    var windowFeatures = '';
    // var CssFileName = 'css/' + CssName + '.css'

    var printHtml = window.open("", windowName, windowFeatures);

    printHtml.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${Title}</title>
          </head>
          <body>
            ${Obj.innerHTML}
          </body>
        </html>
      `);


    // přidat css
    CssNames.forEach(
      function (item) {
        var link = printHtml.document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', 'css/' + item + '.css');
        printHtml.document.getElementsByTagName('head')[0].appendChild(link);
      }
    )

    // console.log(printHtml.document.tostring)

    setTimeout(function () {
      printHtml.document.close();
      printHtml.focus();
      printHtml.print();
      printHtml.close();
    }, 1000);



  }

}